export default class LoginEvent {
    constructor($rootScope) {
        this._rootScope = $rootScope;
    }

    required() {
        this._rootScope.$broadcast('event:auth.loginRequired');
        return this;
    }

    succeeded() {
        this._rootScope.$broadcast('event:auth.loginSucceeded');
        return this;
    }

    failed() {
        this._rootScope.$broadcast('event:auth.loginFailed');
        return this;
    }

    refresh() {
        this._rootScope.$broadcast('event:auth.refresh');
        return this;
    }
}
